

import appsettings from '@/store/app-settings'
import {axiosGet, axiosPost}  from '@/store/api/axiosUtils.js'

const getDocumentTrackingDetail = (params) => {    
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetDocumentTrackingDetail', params)
}

const getDocumentTrackingDetailByUser = (params) => {    
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetDocumentTrackingDetailByUser', params)
}

const GetHistoryDocument = (docId) => { 
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetHistoryDocument?DocId='+docId)
}

const getComplaintAttachFile = (params) => {
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetComplaintAttachFile', params)
}

const getClueAttachFile = (params) => {
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Document/GetClueAttachFile', params)
}

export {
    getDocumentTrackingDetail, 
    getDocumentTrackingDetailByUser,
    GetHistoryDocument,
    getComplaintAttachFile,
    getClueAttachFile,
}